import { useState } from "react";
import styles from "./QueryModals.module.css";
import StatusBadge from "./StatusBadge";
import { formatDateTime } from "./formatDateTime";

const QueryDetailsSummary = ({ data }: { data: any }) => {
  const [imageBroken, setImageBroken] = useState(false);

  const lastRemark = data?.remarks?.length
    ? data.remarks[data.remarks.length - 1]
    : null;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
        <div>
          <h6 className="mb-0">{data?.subject || "No Subject"}</h6>
          <span className="text-muted small">
            Query from {data?.queryOfLevel || "N/A"} level
          </span>
        </div>
        <StatusBadge status={data?.status} />
      </div>

      <table className={styles.detailTable}>
        <tbody>
          <tr>
            <th>
              <i className="uil uil-user"></i>Name
            </th>
            <td>{data?.name || "—"}</td>
            <th>
              <i className="uil uil-envelope"></i>Email
            </th>
            <td>{data?.email || "—"}</td>
          </tr>
          <tr>
            <th>
              <i className="uil uil-phone"></i>Mobile
            </th>
            <td>{data?.phone_number || "—"}</td>
            <th>
              <i className="uil uil-calendar-alt"></i>Created
            </th>
            <td>{formatDateTime(data?.createdAt)}</td>
          </tr>
          <tr>
            <th>
              <i className="uil uil-history"></i>Last Updated
            </th>
            <td>
              {formatDateTime(lastRemark?.updatedAt || data?.updatedAt)}
            </td>
            <th>
              <i className="uil uil-user-check"></i>Updated By
            </th>
            <td>
              {(lastRemark?.queryStatusUpdatedBy || data?.queryStatusUpdatedBy)
                ?.name || "—"}
            </td>
          </tr>
        </tbody>
      </table>

      <div className="mb-2">
        <div className={styles.sectionLabel}>Query</div>
        <div className={styles.queryBox}>
          {data?.query || "No query text provided."}
        </div>
      </div>

      <div>
        <div className={styles.sectionLabel}>Attachment</div>
        {data?.attachment && !imageBroken ? (
          <a
            href={data.attachment}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.attachmentChip}
          >
            <img
              src={data.attachment}
              alt="Attachment thumbnail"
              className={styles.attachmentThumb}
              onError={() => setImageBroken(true)}
            />
            <span className="d-flex align-items-center gap-1 small fw-semibold text-primary">
              View full attachment <i className="uil uil-external-link-alt"></i>
            </span>
          </a>
        ) : (
          <span className={styles.noAttachment}>
            <i className="uil uil-image-slash"></i>
            {data?.attachment && imageBroken
              ? "Attachment could not be loaded."
              : "No attachment uploaded."}
          </span>
        )}
      </div>
    </div>
  );
};

export default QueryDetailsSummary;
